export const labelCropSelection =
    {
        "labelCrop": {
            "en": "Crop",
            "es": "Cultivo",
            "fr": "Culture",
            "pt": "Cultura",
            "ru": "Культуры",
            "zh": "作物"
        }
    };
